import { TableProps } from "antd";
import { CustomTableStyled } from "./index.styled";

interface CustomTableForm extends TableProps<any> {}

export const TableForm: React.FC<CustomTableForm> = ({
  dataSource,
  columns,
  pagination,
  ...props
}) => {
  return (
    <CustomTableStyled
      size="middle"
      rowKey="id"
      columns={columns}
      dataSource={dataSource}
      {...props}
      {...(pagination
        ? {
            pagination: {
              size: "small",
              ...pagination,
              showSizeChanger: false,
              style: { position: "absolute", right: 16, bottom: 0 },
            },
          }
        : { pagination: false })}
    />
  );
};
